/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exit_ApplicationInputs */



/**
* | output |
* | --- |
* | "Exit application" |
*
* @param {Exit_ApplicationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const exit_application = /** @type {((inputs?: Exit_ApplicationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exit_ApplicationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quitter l'application")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anwendung verlassen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esci dall'applicazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заявление о выходе")
	if (locale === "es") return /** @type {LocalizedString} */ ("Salir de la aplicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("退出应用程序")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アプリケーションを終了する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छोड़ने के लिए प्रार्थनापत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sair do aplicativo")
	return /** @type {LocalizedString} */ ("Exit application")
});